import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { Controller } from 'react-hook-form';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';


export default function CheckboxesTags({
    data,
    errors,
    control,
    dynamicField,
    label,
    required,
    id,
    name,
    fullWidth,
    disabled,
    onChange
}) {

    return (
        <>
            <Controller
                name={dynamicField}
                control={control}
                defaultValue={[]}
                rules={{
                    required: {
                        value: required,
                        message: 'This field is required',
                    }
                }}
                render={({ field }) => (
                    <Autocomplete
                        multiple
                        fullWidth={fullWidth}
                        size='small'
                        options={data || []}
                        value={data?.length > 0 ? field?.value?.filter(val => data?.some(option => option[id] === val[id])) : []}
                        // value={field?.value || []}
                        disableCloseOnSelect
                        disabled={disabled}
                        style={{
                            color: disabled && 'black !important',
                            background: disabled && 'hsl(0, 0%, 95%)'
                        }}
                        getOptionLabel={(option) => option[name]}
                        isOptionEqualToValue={(option, value) => option[id] === value[id]}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <Checkbox
                                    icon={<CheckBoxOutlineBlank fontSize="small" />}
                                    checkedIcon={<CheckBox fontSize="small" />}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option[name]}
                            </li>
                        )}
                        onChange={(_, selectedOptions) => onChange ? onChange(selectedOptions) : field.onChange(selectedOptions)}
                        renderInput={(params) => (
                            <TextField {...params} label={label}
                                error={Boolean(errors?.[dynamicField])}
                                helperText={errors?.[dynamicField]?.message} />
                        )}
                    />
                )}
            />
        </>
    );
}